<template>
  <div class="card">
    <Toast />

    <DataTable :value="referencias" v-model:expandedRows="expandedRows" dataKey="Id_referencia" 
               responsiveLayout="scroll" :paginator="true" :rows="10"
               v-model:filters="filters" filterDisplay="menu"
               :scrollable="true" scrollHeight="65vh">
        
        <template #header>
            <div class="grid align-items-center">
                <div class="col-4">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                    </span>
                </div>
                <div class="col-8 flex justify-content-end">
                    <Button v-if="puedeEditar()" class="p-button-success mr-2" icon="pi pi-plus" label="Nueva" @click="showFormReferencia"/>
                    
                    <download-excel 
                        class="btn"
                        :data="referencias"
                        :stringifyLongNum="true"
                        :name="'Referencias.xls'">
                        <Button label="Exportar" icon="pi pi-external-link" class="p-button-warning" />        
                    </download-excel>
                </div>
            </div>
        </template>

        <Column expander style="width: 3rem" />

        <Column v-if="puedeEditar()" style="width:5rem; text-align:center" header="Editar">
             <template #body="slotProps">
                 <Button icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-warning" @click="mostrarDialogEditar(slotProps.data)"/>
             </template>
         </Column>

        <Column field="Referencia" header="Referencia" sortable></Column>
        <Column field="Unidad" header="Unidad" sortable></Column>
        <Column field="Segmento" header="Segmento" sortable></Column>
        <Column field="Vlan" header="Vlan" sortable></Column>
        <Column field="Responsable" header="Responsable" sortable></Column>
        <Column field="Contacto" header="Contacto" sortable></Column>
        <Column field="Asiste" header="Asiste" sortable></Column>

         <template #expansion="slotProps">
            <div class="p-3 surface-50 border-round">
                <h5 class="text-primary mb-2"><i class="pi pi-server mr-2"></i>Detalle de Infraestructura y Servicio</h5>
                
                <div class="grid formgrid">
                    
                    <div class="col-12 mb-0">
                         <span class="text-500 font-bold block mb-1">Dirección / Ubicación</span>
                         <p class="m-0 text-lg text-900">{{slotProps.data.Direccion || 'Sin dirección registrada'}}</p>
                         
                         <div class="mt-1">
                             <small class="text-secondary">
                                <i class="pi pi-map-marker text-primary mr-1"></i>Coordenadas: 
                                <a v-if="slotProps.data.Coordenadas" 
                                   :href="'https://www.google.com/maps?q=' + slotProps.data.Coordenadas" 
                                   target="_blank" 
                                   rel="noopener noreferrer"
                                   class="text-primary font-bold hover:underline cursor-pointer ml-1"
                                   style="text-decoration: none;"
                                   title="Abrir en Google Maps">
                                   {{ slotProps.data.Coordenadas }} <i class="pi pi-external-link" style="font-size: 0.7rem"></i>
                                </a>
                                <span v-else class="ml-1">S/D</span>
                             </small>
                         </div>
                    </div>

                    <div class="col-12 m-0 p-0">
                        <Divider class="my-2" />
                    </div>

                    <div class="col-6 md:col-2 mb-2">
                        <span class="text-500 font-bold block">Tipo Servicio</span>
                        <span class="text-900">{{slotProps.data.Tipo_servicio || 'N/A'}}</span>
                    </div>
                    <div class="col-6 md:col-2 mb-2">
                        <span class="text-500 font-bold block">Proveedor</span>
                        <span class="text-900">{{slotProps.data.Proveedor || 'N/A'}}</span>
                    </div>
                    <div class="col-6 md:col-2 mb-2">
                        <span class="text-500 font-bold block">Velocidad LAN</span>
                        <span class="text-900">{{slotProps.data.Velocidad_LAN || 'N/A'}}</span>
                    </div>
                    <div class="col-6 md:col-2 mb-2">
                        <span class="text-500 font-bold block">Internet Libre</span>
                        <span class="text-900">{{slotProps.data.Internet_libre || 'N/A'}}</span>
                    </div>

                    <div class="col-12 md:col-4 mb-2">
                        <span class="text-500 font-bold block">Correo Contacto</span>
                        <div v-if="slotProps.data.Correo">
                             <a :href="'mailto:' + slotProps.data.Correo" 
                                class="text-primary font-bold hover:underline cursor-pointer"
                                style="text-decoration: none;">
                                <i class="pi pi-envelope mr-1"></i>{{ slotProps.data.Correo }}
                             </a>
                        </div>
                        <span v-else>-</span>
                    </div>

                    <div class="col-6 md:col-2">
                        <span class="text-500 font-bold block">Nodos</span>
                        <span class="text-xl text-900">{{slotProps.data.No_Nodos || '-'}}</span>
                    </div>
                    <div class="col-6 md:col-2">
                        <span class="text-500 font-bold block">Switches</span>
                        <span class="text-900">{{slotProps.data.No_Switches || '-'}}</span>
                    </div>
                    <div class="col-6 md:col-2">
                        <span class="text-500 font-bold block">WiFi</span>
                        <span class="text-900">{{slotProps.data.No_Wifi || '-'}}</span>
                    </div>
                    <div class="col-6 md:col-2">
                        <span class="text-500 font-bold block">Cuartos Com.</span>
                        <span class="text-900">{{slotProps.data.No_Cuartos || '-'}}</span>
                    </div>

                </div>
            </div>
        </template>
    </DataTable>

  <Dialog :header="(objReferencia.Id_referencia) ? 'Editar Referencia': 'Nueva Referencia'" 
            v-model:visible="displayNuevaReferencia" 
            :style="{width: '70vw'}" 
            :modal="true"
            class="p-fluid">
        
        <div class="grid">
             <div class="col-12"><h5 class="m-0">Datos Generales</h5></div>

             <div class="field col-12 md:col-4">
                 <label for="unidad" class="font-bold">Unidad <span class="text-red-500">*</span></label>
                 <InputText id="unidad" v-model="objReferencia.Unidad" :class="{'p-invalid': submittedFormReferencia && !objReferencia.Unidad}" />
                 <small v-if="submittedFormReferencia && !objReferencia.Unidad" class="p-error">La Unidad es obligatoria.</small>
             </div>

             <div class="field col-12 md:col-4">
                 <label for="referencia" class="font-bold">Referencia <span class="text-red-500">*</span></label>
                 <InputText id="referencia" v-model="objReferencia.Referencia" :class="{'p-invalid': submittedFormReferencia && !objReferencia.Referencia}" />
                 <small v-if="submittedFormReferencia && !objReferencia.Referencia" class="p-error">La Referencia es obligatoria.</small>
             </div>

             <div class="field col-12 md:col-4">
                 <label for="segmento" class="font-bold">Segmento <span class="text-red-500">*</span></label>
                 <InputText id="segmento" v-model="objReferencia.Segmento" :class="{'p-invalid': submittedFormReferencia && !objReferencia.Segmento}" />
                 <small v-if="submittedFormReferencia && !objReferencia.Segmento" class="p-error">El Segmento es obligatorio.</small>
             </div>
             
             <div class="field col-6 md:col-2">
                 <label class="font-bold">Vlan <span class="text-red-500">*</span></label>
                 <InputText v-model="objReferencia.Vlan" :class="{'p-invalid': submittedFormReferencia && !objReferencia.Vlan}" />
                 <small v-if="submittedFormReferencia && !objReferencia.Vlan" class="p-error">Requerido.</small>
             </div>

             <div class="field col-12 md:col-5">
                 <label>Responsable</label>
                 <InputText v-model="objReferencia.Responsable" />
             </div>
             <div class="field col-12 md:col-5">
                 <label>Contacto</label>
                 <InputText v-model="objReferencia.Contacto" />
             </div>
             <div class="field col-12 md:col-6">
                 <label>Asiste</label>
                 <InputText v-model="objReferencia.Asiste" />
             </div>
             <div class="field col-12 md:col-6">
                 <label>Tipo de Servicio</label>
                 <InputText v-model="objReferencia.Tipo_servicio" />
             </div>
             <div class="field col-12 md:col-6">
                 <label>Proveedor</label>
                 <InputText v-model="objReferencia.Proveedor" />
             </div>
             <div class="field col-12 md:col-3">
                 <label>Velocidad LAN</label>
                 <InputText v-model="objReferencia.Velocidad_LAN" />
             </div>
             <div class="field col-12 md:col-3">
                 <label>Internet Libre</label>
                 <InputText v-model="objReferencia.Internet_libre" />
             </div>

             <div class="col-12">
                <Divider align="center">
                    <span class="p-tag p-tag-info">Infraestructura Técnica</span>
                </Divider>
             </div>

             <div class="field col-6 md:col-2">
                 <label>No. Nodos</label>
                 <InputText v-model="objReferencia.No_Nodos" placeholder="0" />
             </div>
             <div class="field col-6 md:col-2">
                 <label>No. Switches</label>
                 <InputText v-model="objReferencia.No_Switches" placeholder="0" />
             </div>
             <div class="field col-6 md:col-2">
                 <label>No. Wifi</label>
                 <InputText v-model="objReferencia.No_Wifi" placeholder="0" />
             </div>
             <div class="field col-6 md:col-2">
                 <label>Cuartos Com.</label>
                 <InputText v-model="objReferencia.No_Cuartos" placeholder="0" />
             </div>
             
             <div class="field col-12 md:col-4">
                 <label>Correo Contacto</label>
                 <InputText v-model="objReferencia.Correo" :class="{'p-invalid': errorCorreo}" @input="validarCorreoEnVivo" />
                 <small v-if="errorCorreo" class="p-error">Formato de correo inválido (ej. usuario@dominio.com)</small>
             </div>
             
             <div class="field col-12 md:col-4">
                 <label>Coordenadas (Lat, Long)</label>
                 <InputText v-model="objReferencia.Coordenadas" placeholder="Ej: 21.123, -89.123" />
             </div>
             <div class="field col-12 md:col-8">
                 <label>Dirección del Inmueble</label>
                 <Textarea v-model="objReferencia.Direccion" rows="2" autoResize />
             </div>
        </div>

        <template #footer>
             <Button label="Cancelar" icon="pi pi-times" @click="closeDialogReferencia" class="p-button-text"/>
             <Button label="Guardar" icon="pi pi-check" @click="submitFormReferencia" :loading="loading" />
        </template>
    </Dialog>  
  </div>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import Srvr from "../service/Referencias";
import Utilerias from '../utilidades/Utilerias';

export default {
    data() {
        return {
            referencias: [],
            expandedRows: [], 
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            },
            objReferencia: {},
            displayNuevaReferencia: false,
            submittedFormReferencia: false,
            loading: false,
            errorCorreo: false // Controla si el correo es inválido
        }
    },
    methods: {
        cargaInicial() {
            var t = this;
            t.loading = true;
            var ctlSvr = new Srvr();
            
            ctlSvr.getReferencias(t).then((res) => {
                if (res && res.data && Array.isArray(res.data)) {
                    t.referencias = res.data;
                } else if (Array.isArray(res)) {
                    t.referencias = res;
                } else if (res.data) {
                     t.referencias = []; 
                }
                t.loading = false;
            }).catch(() => t.loading = false);
        },

        showFormReferencia() {
            // Inicializar campos explícitamente y limpiar errores
            this.objReferencia = { 
                Id_referencia: 0,
                Unidad: '', Referencia: '', Segmento: '', Vlan: '',
                No_Nodos: '', No_Switches: '', No_Wifi: '', No_Cuartos: '',
                Correo: '', Coordenadas: '', Direccion: ''
            }; 
            this.submittedFormReferencia = false;
            this.errorCorreo = false;
            this.displayNuevaReferencia = true;
        },

        mostrarDialogEditar(data) {
            this.submittedFormReferencia = false;
            this.errorCorreo = false;
            this.displayNuevaReferencia = true;
            this.objReferencia = { ...data };
            
            // Validar correo al abrir por si ya venía mal
            if(this.objReferencia.Correo) this.validarCorreoEnVivo();
        },

        closeDialogReferencia() {
            this.submittedFormReferencia = false;
            this.displayNuevaReferencia = false;
            this.objReferencia = {};
        },

        // Validador de correo con Regex simple
        validarCorreoEnVivo() {
            if (!this.objReferencia.Correo) {
                this.errorCorreo = false;
                return;
            }
            // Expresión regular estándar para emails
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            this.errorCorreo = !regex.test(this.objReferencia.Correo);
        },

        submitFormReferencia() {
            var t = this;
            t.submittedFormReferencia = true;

            // Validar Campos Obligatorios
            let esInvalido = !t.objReferencia.Referencia || !t.objReferencia.Unidad || !t.objReferencia.Segmento || !t.objReferencia.Vlan;

            // Validar Correo (si hay error visible)
            if (t.errorCorreo) esInvalido = true;

            // Si hay error, detener y hacer SCROLL
            if (esInvalido) {
                t.$toast.add({ severity: 'error', summary: 'Error', detail: 'Verifica los campos obligatorios marcados en rojo.', life: 3000 });
                
                // Busca el primer elemento con la clase '.p-invalid' y hace scroll hacia él
                t.$nextTick(() => {
                    const primerError = document.querySelector('.p-invalid');
                    if (primerError) {
                        primerError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        primerError.focus();
                    }
                });
                return; // Detiene el guardado
            }

            // Si todo está bien, procede a guardar
            t.loading = true;
            var ctlSvr = new Srvr();            

            let promise;
            if (t.objReferencia.Id_referencia && t.objReferencia.Id_referencia > 0) {
                promise = ctlSvr.updateReferencia(t, t.objReferencia);
            } else {
                promise = ctlSvr.addReferencia(t, t.objReferencia);
            }

            promise.then((res) => {
                t.loading = false;
                if (res && (res.ok || res != null)) {
                    t.$toast.add({
                        severity: "success",
                        summary: "Éxito",
                        detail: "Información guardada correctamente.",
                        life: 3000,
                    });
                    t.closeDialogReferencia();
                    t.cargaInicial(); 
                }
            }).catch(() => t.loading = false);
        },

        puedeEditar() {
            let util = new Utilerias();
            return util.isPermiso("EDITOR_CATALOGOS") == true || util.isAdmin() || util.isAdminTelecom();
        }
    },
    mounted() {
        this.cargaInicial();
    }
}
</script>

<style scoped>
::v-deep(.p-datatable-row-expansion) {
    background-color: #f8f9fa;
}
</style>